import Point from 'Utility/Point';
import { applyDefaultButtonAnimation } from 'System/UI/UIHelper';
import Overlay from 'Prototype/UI/Overlay';
import Element from '../../../../Prototype/UI/Element';
import GameObject, { GameObjectEvent } from 'GameObject/GameObject';
import PIXIRenderer from 'System/Render/PIXIRenderer';
import TransformComponent from 'Component/Transform';
import { SeasonPassInfo } from 'Layouts/Quests/SeasonPass/SeasonPassInfo';
import Sprite from 'Prototype/Sprite';
import { hasFlag } from 'State/Player/PlayerFlagHelper';
import Game from 'Game';
import { SEASON_PASS_INTRO_INFO } from 'Constants/SeasonPass';
import { PlayerActions } from 'State/Player/PlayerActions';
import { StartAnimation } from 'System/Animation/AnimationHelper';
import { PlaySound } from 'System/Audio/AudioHelper';
import Renderable from 'Component/Renderable';
import { AnimationClipEvent } from 'System/Animation/AnimationClip';
import ElementComponent from 'Component/UI/Element';

export class SeasonPassInfoPopup extends Element {
    private overlay: Overlay;
    private layout: any;
    private leftDeco: Sprite;
    private rightDeco: Sprite;

    public create(): void {
        super.create({
            type: 'group',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 0, 0, 0],
            },
        });

        this.overlay = GameObject.Instantiate(Overlay, {
            name: 'overlay',
            preventInteraction: true,
            anchors: [0, 0, 0, 0],
            alpha: 0.9,
            color: [0, 0, 0, 225],
        });
        this.addChild(this.overlay);

        this.layout = new SeasonPassInfo();
        this.addChild(this.layout.root);

        this.layout.root.getComponent(TransformComponent).y -= this.container.height / 4;
        this.layout.root.getComponent(TransformComponent).x -= this.container.width / 2 - 30;

        this.leftDeco = GameObject.Instantiate(Sprite, {
            name: 'decoLeft',
            texture: 'grass_left',
            anchor: new Point(0, 1),
            x: -PIXIRenderer.renderer.width / 2,
            y: PIXIRenderer.renderer.height / 2,
        });

        this.rightDeco = GameObject.Instantiate(Sprite, {
            name: 'decoRight',
            texture: 'grass_right',
            anchor: new Point(1, 1),
            x: PIXIRenderer.renderer.width / 2,
            y: PIXIRenderer.renderer.height / 2,
        });

        this.addChild(this.leftDeco);
        this.addChild(this.rightDeco);

        this.leftDeco.addComponent(Renderable);
        this.leftDeco.addComponent(ElementComponent);
        this.rightDeco.addComponent(Renderable);
        this.rightDeco.addComponent(ElementComponent);

        const { closeButton, button } = this.layout;
        [closeButton, button].forEach(o => applyDefaultButtonAnimation(o));
        closeButton.once(GameObjectEvent.POINTER_UP, () => {
            this.destroy();
        });
        button.once(GameObjectEvent.POINTER_UP, () => {
            this.destroy();
        });

        if (!hasFlag(Game.store.getState().playerState, SEASON_PASS_INTRO_INFO)) {
            PlayerActions.setFlag({ id: SEASON_PASS_INTRO_INFO, });
        }

        this.show();
    }

    public show() {
        this.getComponent(Renderable).visible = false;
        this.overlay.getComponent(Renderable).alpha = 0;
        PlaySound('swoosh-1');

        StartAnimation(this, 'MenuShow');
        StartAnimation(this.overlay, 'OverlayFadeIn', { delay: 250 });
    }

    public destroy(): void {
        PlaySound('swoosh-2');
        StartAnimation(this.overlay, 'OverlayFadeOut')
        StartAnimation(this, 'MenuHide', { delay: 350 }).once(AnimationClipEvent.COMPLETE, () => {
            super.destroy();
        });
    }
}
